import { FunctionComponent, useEffect, useRef } from 'react';

import {
  BetOnAllControlConnected,
  StatisticsControlConnected,
  Tooltip,
  TooltipPositions,
  UndoControlConnected,
  useGameStateSlice,
  useIsLargerThanWide,
  useIsPortrait,
} from '@pp/core';

import { useAllLimitConnected } from '../../hooks/useAllLimitConnected';
import { useBetOnAllCallbackConnected } from '../../hooks/useBetOnAllCallbackConnected';
import { MWGameGridObserver } from '../../MWGameGridObserver';
import styles from './leftControlsCell.module.css';

export const LeftControlsCellConnected: FunctionComponent = () => {
  const betOnAll = useBetOnAllCallbackConnected();
  const isBetsOpenStatus = useGameStateSlice.isBetsOpenStatus();
  const isWide = useIsLargerThanWide();
  const isPortrait = useIsPortrait();
  const betOnAllTooltip = useAllLimitConnected();
  const leftControlsRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    MWGameGridObserver.addMeasurer('leftControls', () => {
      return {
        leftControlsBottom: leftControlsRef.current?.getBoundingClientRect().bottom || null,
      };
    });
  }, []);

  if (isWide) return null;

  return (
    <div className={styles.leftControls} ref={leftControlsRef}>
      {!isPortrait ? (
        <div
          className={`${styles.leftControls__item} ${styles.leftControls__item_betOnAll} ${
            !isBetsOpenStatus ? styles.leftControls__item_hidden : null
          }`}
        >
          <Tooltip
            text={betOnAllTooltip || ''}
            disabled={!betOnAllTooltip}
            position={TooltipPositions.Right}
            displayOnTouch={true}
          >
            <BetOnAllControlConnected onClick={betOnAll} />
          </Tooltip>
        </div>
      ) : null}
      <div className={styles.leftControls__item}>
        <StatisticsControlConnected />
      </div>
      {isPortrait ? (
        <div className={`${styles.leftControls__item}`}>
          <UndoControlConnected />
        </div>
      ) : null}
    </div>
  );
};
